module.exports = __webpack_public_path__ + "img/app1.60a2499b.png";